export default {
      id: "i-noun-health-usage",
      viewBox: "0 0 38 43",
      url: __webpack_public_path__ + "img/sprite.svg#i-noun-health",
      toString: function () {
        return this.url;
      }
    }